/**
 * Returns true if the value is undefined, null, or empty string
 * @param value
 * @returns {boolean}
 */
export function isValueFalsey(value) {
  return value === undefined || value === null || value === '';
}

/**
 * Returns true if the value is not undefined, not null, and not an empty string;
 * @param value
 * @returns {boolean}
 */
export function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
}